import { MAX_DASHBOARD_LABEL_LENGTH } from '../../types/api/dashboard/DashboardLimits';

const COPY_SUFFIX = ' (copy)';

const TRAILING_HALF_EMOJI = /[\uD800-\uDBFF]$/;

/**
 * The name a copied board gets when the author does not pick one
 */
export function defaultDashboardCopyLabel(sourceLabel: string): string {
    const cut = sourceLabel.trim().slice(0, MAX_DASHBOARD_LABEL_LENGTH - COPY_SUFFIX.length);
    const name = (TRAILING_HALF_EMOJI.test(cut) ? cut.slice(0, -1) : cut).trimEnd();

    // A board nobody named has an empty label, so without this the copy would start with a space.
    return `${name}${COPY_SUFFIX}`.trim();
}
